import { createAsyncThunk } from '@reduxjs/toolkit';

import { GetPlantApiListProps, GetPlantApiProps } from 'entities/PlantApi';

import * as service from 'services/plant_api.service';

export const getPlantApiList = createAsyncThunk(
  'plantApi/list',
  async (data: GetPlantApiListProps, thunkApi) => {
    try {
      const response = await service.getPlantApiListService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getPlantApi = createAsyncThunk(
  'plantApi/get',
  async (data: GetPlantApiProps, thunkApi) => {
    try {
      const response = await service.getPlantApiService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
